import { PropsWithChildren, createContext, useContext } from "react";

import { ImageSourcePropType } from "react-native";

import { CartReviewProduct } from "../../CartReview";
import { TransactionListItem, TransactionOrWithdrawal } from "../types";

type ContextType = {
  // fetchers
  getTransaction: (uuid: string) => Promise<TransactionOrWithdrawal>;
  getTransactionSummary: (uuid: string) => Promise<TransactionListItem>;

  // handlers
  onSelectCartItem: (item: CartReviewProduct) => void;
  onEditBankPress: () => void;
  onWhatsappHelpPress: () => void;
  onErrorClose: () => void;

  //actions
  patchTransaction: (transaction: TransactionListItem) => Promise<void>;
  cancelPayment: (params: { uuid: string }) => Promise<void>;
  markAsReadyForPickup: (params: { fulfillment_id: string }) => Promise<void>;
  markAsDelivered: (params: {
    charge_type: string;
    charge_id: string;
  }) => Promise<void>;
  markAsPaid: (params: { uuid: string; email: string }) => Promise<void>;

  copyToClipboard: (text: string) => Promise<void>;
  /** Must return a boolean that determines if share was succesful */
  shareMessage: (params: { message: string; url: string }) => Promise<boolean>;
  resendReceipt: (params: {
    charge_type: string;
    charge_id: string;
    email: string;
  }) => Promise<void>;
  resendRefundReceipt: (params: { uuid: string }) => Promise<void>;
  resendPaymentInstructions: (params: { uuid: string }) => Promise<void>;

  // constants
  withdrawBanks: Array<{ id: number; name: string; logo: ImageSourcePropType }>;
};

const Context = createContext<ContextType | null>(null);

export default function useTransactionDetailsAPI() {
  const ctx = useContext(Context);
  if (!ctx) throw new Error("Missing TransactionDetailsContextProvider");
  return ctx;
}

export function TransactionDetailsAPIProvider({
  children,
  ...props
}: PropsWithChildren<ContextType>) {
  return <Context.Provider value={props}>{children}</Context.Provider>;
}
